import { render, staticRenderFns } from "./ContestPlayerRewardsTable.vue?vue&type=template&id=53681c9f&scoped=true&"
import script from "./ContestPlayerRewardsTable.vue?vue&type=script&lang=js&"
export * from "./ContestPlayerRewardsTable.vue?vue&type=script&lang=js&"
import style0 from "./ContestPlayerRewardsTable.vue?vue&type=style&index=0&id=53681c9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53681c9f",
  null
  
)

export default component.exports